import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";

import { Observable, Subject } from "rxjs";

import { PermissionsEnumerationResult } from "../models/enumerated.permission.model";

@Injectable()
export class PermissionsService {

  constructor(public readonly httpClient: HttpClient) {
  }

  get(): Observable<PermissionsEnumerationResult> {
    return this.httpClient.get<PermissionsEnumerationResult>(`/api/admin/permissions/`);
  }
}